<template>
    <option-with-number-input
        checkbox-id="branches_automated_notify_days_checkbox"
        :checked="branchesAutomatedNotifyDaysCheckbox"
        input-name="automated_notify_days"
        :input-value="branchesAutomatedNotifyDaysInput"
        :is-admin
    >
        <template #beforeInput>Automatically re-notify clients after </template>
        <template #afterInput> days if they have not logged in </template>
        <template #tooltip>
            <span>
                <i
                    aria-hidden="true"
                    class="fas fa-info-circle help-bubble"
                    title="Automatically send a one-time reminder email to clients who have not logged in x days since file creation."
                ></i>
            </span>
        </template>
    </option-with-number-input>

    <div class="form-group row col">
        <div class="col-md-10 offset-md-1">
            <strong>Automated Task Reminders</strong>
        </div>
    </div>
    <option-with-number-input
        v-model:checked="parentEnabled"
        checkbox-id="max_number_of_reminders_checkbox"
        :input-max="10"
        :input-min="1"
        input-name="max_number_of_reminders"
        :input-value="maxNumberOfRemindersInput"
        :is-admin
        @checkbox-change="parentEnabled = $event"
    >
        <template #beforeInput>The maximum number of times a client reminder will be sent: </template>
    </option-with-number-input>
    <option-with-number-input
        checkbox-id="bav_notification"
        :checked="bavNotificationCheckbox"
        class="ml-5"
        :disabled="!parentEnabled"
        :input-max="10"
        :input-min="1"
        input-name="bav_notification_frequency_days"
        :input-value="bavNotificationInput"
        :is-admin
    >
        <template #beforeInput>Seller bank verification &ndash; Automatically re-notify the client every </template>
        <template #afterInput> days </template>
    </option-with-number-input>
    <option-with-number-input
        checkbox-id="idv_notification"
        :checked="idvNotificationCheckbox"
        class="ml-5"
        :disabled="!parentEnabled"
        :input-max="10"
        :input-min="1"
        input-name="idv_notification_frequency_days"
        :input-value="idvNotificationInput"
        :is-admin
    >
        <template #beforeInput>Identity verification &ndash; Automatically re-notify the client every </template>
        <template #afterInput> days </template>
    </option-with-number-input>
    <option-with-number-input
        checkbox-id="esign_notification"
        :checked="esignNotificationCheckbox"
        class="ml-5"
        :disabled="!parentEnabled"
        :input-max="10"
        :input-min="1"
        input-name="esign_notification_frequency_days"
        :input-value="esignNotificationInput"
        :is-admin
    >
        <template #beforeInput>eSign document &ndash; Automatically re-notify the client every </template>
        <template #afterInput> days </template>
    </option-with-number-input>
    <option-with-number-input
        checkbox-id="doc_task_notification"
        :checked="docTaskNotificationCheckbox"
        class="ml-5"
        :disabled="!parentEnabled"
        :input-max="10"
        :input-min="1"
        input-name="doc_task_notification_frequency_days"
        :input-value="docTaskNotificationInput"
        :is-admin
    >
        <template #beforeInput>Request document &ndash; Automatically re-notify the client every </template>
        <template #afterInput> days </template>
    </option-with-number-input>
</template>

<script setup lang="ts">
import OptionWithNumberInput from '@/components/Views/Company/Settings/OptionWithNumberInput.vue';
import { ref } from 'vue';

const props = defineProps<{
    isAdmin: boolean;
    automatedTasksReminderSettings: {
        branchesAutomatedNotifyDaysCheckbox: boolean;
        branchesAutomatedNotifyDaysInput: number;
        maxNumberOfRemindersCheckbox: boolean;
        maxNumberOfRemindersInput: number;
        bavNotificationCheckbox: boolean;
        bavNotificationInput: number;
        idvNotificationCheckbox: boolean;
        idvNotificationInput: number;
        esignNotificationCheckbox: boolean;
        esignNotificationInput: number;
        docTaskNotificationCheckbox: boolean;
        docTaskNotificationInput: number;
    };
}>();

const {
    branchesAutomatedNotifyDaysCheckbox,
    branchesAutomatedNotifyDaysInput,
    maxNumberOfRemindersInput,
    bavNotificationCheckbox,
    bavNotificationInput,
    idvNotificationCheckbox,
    idvNotificationInput,
    esignNotificationCheckbox,
    esignNotificationInput,
    docTaskNotificationCheckbox,
    docTaskNotificationInput,
} = props.automatedTasksReminderSettings;

const parentEnabled = ref(props.automatedTasksReminderSettings.maxNumberOfRemindersCheckbox);
</script>
